module.exports = __webpack_public_path__ + "static/media/27OCHA15.77cf1cff.jpg";